module.exports = __webpack_public_path__ + "bb42b5c96a117ccb6ca65363070a05dd.svg";